import { persistProject } from "./helpers/persistProject";

export default {
  setSoilTypes(soils) {
    return persistProject({type: 'SET_SOIL_TYPES', soils});
  },

  setSoilBoundaries(boundaries) {
    return persistProject({type: 'SET_BOUNDARIES', boundaries});
  },

  setBulkSoil(bulkSoil) {
    return persistProject({type: 'SET_BULK_SOIL', bulkSoil});
  },

  resetSoil() {
    return persistProject({type: 'SOIL_RESET'});
  },

  setBlowCountsSD(blowCountsSD) {
    return persistProject({type: 'SET_BLOW_COUNT_SD', blowCountsSD});
  }
};
